import { ToggleItem } from 'components/ToggleListModal/types';
import messages from 'constants/constants.messages';

const PRESS_RELEASE = 'Press Release';
const EARNINGS_AND_STOCK_NEWS = 'Earnings & Stock News';
export const JOB_POSTINGS = 'Job Postings';
export const MARKET_RESEARCH_REPORTS = 'Market Research Reports';
const SPORTS_NEWS = 'Sports Filter';

export const CONTENT_TYPE_VALUES_MESSAGES = {
  [PRESS_RELEASE]: messages.constantsPressReleaseSearchContentType,
  [EARNINGS_AND_STOCK_NEWS]:
    messages.constantsEarningsAndStockNewsSearchContentType,
  [JOB_POSTINGS]: messages.constantsJobPostingsSearchContentType,
  [MARKET_RESEARCH_REPORTS]:
    messages.constantsMarketResearchReportsSearchContentType,
  [SPORTS_NEWS]: messages.constantsSportsNewsSearchContentType,
};

export const CONTENT_TYPE_VALUES_LENGTH = Object.keys(
  CONTENT_TYPE_VALUES_MESSAGES,
).length;

export const contentTypeFilterLocalSource = (
  formatMessage = message => '',
): ToggleItem[] =>
  [
    {
      title: formatMessage(CONTENT_TYPE_VALUES_MESSAGES[PRESS_RELEASE]),
      value: PRESS_RELEASE,
    },
    {
      title: formatMessage(
        CONTENT_TYPE_VALUES_MESSAGES[EARNINGS_AND_STOCK_NEWS],
      ),
      value: EARNINGS_AND_STOCK_NEWS,
    },
    {
      title: formatMessage(CONTENT_TYPE_VALUES_MESSAGES[JOB_POSTINGS]),
      value: JOB_POSTINGS,
    },
    {
      title: formatMessage(
        CONTENT_TYPE_VALUES_MESSAGES[MARKET_RESEARCH_REPORTS],
      ),
      value: MARKET_RESEARCH_REPORTS,
    },
    {
      title: formatMessage(CONTENT_TYPE_VALUES_MESSAGES[SPORTS_NEWS]),
      value: SPORTS_NEWS,
    },
  ].map((contentType: { title: string; value: string }, id) => ({
    id,
    name: contentType.title,
    value: contentType.value,
  }));
